import Channel from '../../classes/channel';
import Event from '@shared/classes/event';
import Modals from '@shared/types/enums/modals';
import Pages from '@pages';
import ParentalUtils from '@shared/utils/parental';
import { clearPauseAd } from '@shared/store/slices/ads.slice';
import { popRoute, pushRoute } from '../../store/thunks/route.thunk';
import { setChannel } from '../../store/thunks/channels.thunk';
import { setModal, setModalParams } from '@shared/store/slices/modal.slice';
import { store } from '../../store/store';
import { updateParams } from '@shared/store/slices/router.slice';
import AnalyticsInstance from '@shared/utils/analytics';
import { OmnitrackPlaybackInteraction } from '@tvup/omnitrack-js';

interface Props {
  channel?: Channel | number;
  checkParental?: boolean;
  overwrite?: boolean;
  pop?: boolean;
  restart?: boolean;
}

function accessChannel(props: Props) {
  // Set new channel
  const { channel, overwrite, pop, restart } = props;
  if (channel) {
    store.dispatch(clearPauseAd());
    store.dispatch(setChannel(channel));
    const { router } = store.getState();
    // Only keep one player at the stack at most
    if (pop || router.route.stack.includes(Pages.ZAPPER)) {
      store.dispatch(popRoute());
      store.dispatch(
        updateParams({
          content: channel,
          ...(restart ? { restart, position: 0 } : null),
        })
      );
    } else {
      setTimeout(() => {
        // TBD: Without this currentChannel doesn't change in time for kepler
        store.dispatch(
          pushRoute({
            route: { Page: Pages.ZAPPER, overwrite },
            params: {
              current: {
                content: channel,
                ...(restart ? { restart, position: 0 } : null),
              },
              stack: {
                channel: channel,
                stacked: !overwrite,
              },
              push: true,
            },
          })
        );
      });
    }
  }
}

export default function goToChannel(props: Props, deadman = false) {
  const { channel, checkParental } = props;
  store.dispatch(clearPauseAd());
  if (deadman) {
    AnalyticsInstance.setPlaybackInteraction(
      OmnitrackPlaybackInteraction.AUTOMATIC
    );
  } else {
    AnalyticsInstance.setPlaybackInteraction(
      OmnitrackPlaybackInteraction.CLICK
    );
  }
  if (
    !(
      checkParental &&
      typeof channel !== 'number' &&
      ParentalUtils.checkParentalControl(channel?.currentEvent as Event, () => {
        store.dispatch(
          setModalParams({
            callback: () => {
              accessChannel(props);
            },
          })
        );
        store.dispatch(setModal(Modals.PARENTAL_PIN_GENERIC));
      })
    )
  ) {
    accessChannel(props);
  }
}
